// client/src/pages/admin/AdminConfigPage.jsx
// Configuration page housing Prof-iX Content and Notifications sub-tabs.

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ProfileHeader from '../../components/headers/profileHeader';
import SharedHeader from '../../components/headers/sharedHeader1';
import BackButton from '../../components/customs/backButton';
import ReindexPanel from './ReindexPanel';
import AdminFCMPanel from './AdminFCMPanel';
import { GlobalContext } from '../../context/provider';
import { useContext } from 'react';

import '../../styles/globalstyles.css';
import './adminDashboard.css';

const AdminConfigPage = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { authState: { authData } } = useContext(GlobalContext);

  // Allow a deep-link to a specific sub-tab via navigation state
  const [activeSubTab, setActiveSubTab] = useState(
    location.state?.activeSubTab || 'profix'
  );

  const handleBack = () => {
    navigate('/admin/dashboard', {
      state: { activeTab: location.state?.previousTab || 'management' },
    });
  };

  const profileHeaderData = {
    ...authData,
    // title: '⚙️ Configuration',
  };

  return (
    <div className="main-container">
      <div className="main-content">

        {/* Header */}
        <div className="header-row">
          <ProfileHeader
            data={profileHeaderData}
            activePage="admin/dashboard"
          />
          <div className="headerMiddle">
            <img src="/images/prof_ix.png" alt="Logo" className="header-logo" />
          </div>
          <SharedHeader notificationCount={0} icons={[]} />
        </div>

        {/* Toolbar */}
        <div className="ai-notebook-toolbar">
          <div className="ai-notebook-toolbar-left">
            <BackButton 
              to="/admin/dashboard"
              activeTab="management"
              label="←"
              bgColor="#6b7280"
            />
            <span className="ai-notebook-flow-name">
              <span className="ai-notebook-lab-tag">⚙️ Admin Configuration</span>
              {/* <span className="ai-notebook-session-id">📚 Course: {courseInfo?.title} ({courseInfo?.courseId})</span> */}
            </span>
          </div>
          {/* <div className="ai-notebook-toolbar-right">
          </div> */}
        </div>

        {/* Back button + Sub-tab bar */}
        <div className="top-tab-container">
          <button
            className={`tab-button ${activeSubTab === 'profix' ? 'active-tab' : ''}`}
            onClick={() => setActiveSubTab('profix')}
          >
            🤖 Add Content
          </button>
          <button
            className={`tab-button ${activeSubTab === 'fcm' ? 'active-tab' : ''}`}
            onClick={() => setActiveSubTab('fcm')}
          >
            🔔 Register Tokens
          </button>
        </div>

        {/* Sub-tab content */}
        {activeSubTab === 'profix' && <ReindexPanel />}
        {activeSubTab === 'fcm'    && <AdminFCMPanel />}

      </div>
    </div>
  );
};

export default AdminConfigPage;
